function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import { START_DATE, END_DATE, HORIZONTAL_ORIENTATION, OPEN_UP, VERTICAL_ORIENTATION } from 'react-dates/constants';
import 'scss/cosmos_date_range.scss';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      startDate: null,
      endDate: null,
      endDateCalendarFocused: false,
      startDateCalendarFocused: false
    };

    _this.onStartDateChange = function (startDate) {
      _this.props.actions.setCurrentDateRange(_this.props.countryID, _this.props.plotID, [startDate, _this.props.endDate]);

      _this.props.updateBrush([startDate.toDate(), _this.props.endDate.toDate()]);
    };

    _this.onStartFocusChange = function (_ref) {
      var focused = _ref.focused;

      _this.setState(function () {
        return {
          startDateCalendarFocused: focused
        };
      });
    };

    _this.onEndDateChange = function (endDate) {
      _this.props.actions.setCurrentDateRange(_this.props.countryID, _this.props.plotID, [_this.props.startDate, endDate]);

      _this.props.updateBrush([_this.props.startDate.toDate(), endDate.toDate()]);
    };

    _this.onEndFocusChange = function (_ref2) {
      var focused = _ref2.focused;

      _this.setState(function () {
        return {
          endDateCalendarFocused: focused
        };
      });
    };

    _this.isOutsideRange = function (momentDate) {
      return _this.state.focusedInput === END_DATE && momentDate.isBefore(_this.props.startDate, 'day') || _this.state.focusedInput === START_DATE && momentDate.isAfter(_this.props.endDate, 'day') || _this.isDateOutsideOfPossibleRange(momentDate);
    };

    return _this;
  }

  _createClass(Calendar, [{
    key: "isDateOutsideOfPossibleRange",
    value: function isDateOutsideOfPossibleRange(momentDate) {
      return !this.props.range || momentDate.isBefore(this.props.range[0], 'day') || momentDate.isAfter(this.props.range[1], 'day');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: "cosmos-date-range"
      }, React.createElement("div", {
        className: "cosmos-date-range__connecting-label cosmos-date-range__label-text"
      }, 'Download data from'), React.createElement("label", {
        className: "cosmos-date-range__label-wrapper",
        htmlFor: "cosmos-date-range-".concat(this.props.plotID, "-start-date")
      }, ' ', React.createElement("form", null, this.props.calendar === 'readOnly' ? React.createElement(SingleDatePicker, {
        date: this.props.startDate,
        id: "cosmos-date-range-".concat(this.props.plotID, "-start-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        openDirection: OPEN_UP,
        enableOutsideDays: true,
        onDateChange: function onDateChange(a) {
          return _this2.onEndDateChange(a);
        },
        focused: this.state.startDateCalendarFocused,
        onFocusChange: this.onEndFocusChange,
        numberOfMonths: 1,
        isOutsideRange: function isOutsideRange(a) {
          return _this2.isOutsideRange(a);
        },
        displayFormat: "MM/DD/YYYY",
        readOnly: true
      }) : React.createElement(SingleDatePicker, {
        date: this.props.startDate,
        id: "cosmos-date-range-".concat(this.props.plotID, "-start-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        openDirection: OPEN_UP,
        enableOutsideDays: true,
        onDateChange: function onDateChange(a) {
          return _this2.onStartDateChange(a);
        },
        focused: this.state.startDateCalendarFocused,
        onFocusChange: this.onStartFocusChange,
        numberOfMonths: 1,
        isOutsideRange: function isOutsideRange(a) {
          return _this2.isOutsideRange(a);
        },
        displayFormat: "MM/DD/YYYY",
        readOnly: true
      }))), React.createElement("div", {
        className: "cosmos-date-range__connecting-label cosmos-date-range__label-text"
      }, mapTextVariableNameToStaticLocalizedText('COSMOS_DATE_RANGE_CONNECTING_LABEL')), React.createElement("label", {
        className: "cosmos-date-range__label-wrapper",
        htmlFor: "cosmos-date-range-".concat(this.props.plotID, "-end-date")
      }, React.createElement("form", null, this.props.calendar === 'readOnly' ? React.createElement(SingleDatePicker, {
        date: this.props.endDate,
        id: "cosmos-date-range-".concat(this.props.plotID, "-end-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        openDirection: OPEN_UP,
        enableOutsideDays: true,
        focused: this.state.endDateCalendarFocused,
        numberOfMonths: 1,
        readOnly: true,
        onDateChange: function onDateChange(a) {
          return _this2.onEndDateChange(a);
        },
        isOutsideRange: function isOutsideRange(a) {
          return _this2.isOutsideRange(a);
        },
        onFocusChange: this.onEndFocusChange,
        displayFormat: "MM/DD/YYYY"
      }) : React.createElement(SingleDatePicker, {
        date: this.props.endDate,
        id: "cosmos-date-range-".concat(this.props.plotID, "-end-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        openDirection: OPEN_UP,
        enableOutsideDays: true,
        onDateChange: function onDateChange(a) {
          return _this2.onEndDateChange(a);
        },
        focused: this.state.endDateCalendarFocused,
        onFocusChange: this.onEndFocusChange,
        numberOfMonths: 1,
        readOnly: true,
        isOutsideRange: function isOutsideRange(a) {
          return _this2.isOutsideRange(a);
        },
        displayFormat: "MM/DD/YYYY"
      }))));
    }
  }]);

  return Calendar;
}(React.Component);

export { Calendar as default };
Calendar.propTypes = {
  countryID: PropTypes.string.isRequired,
  plotID: PropTypes.string.isRequired,
  range: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  actions: PropTypes.object.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  updateBrush: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  isMobileWidth: PropTypes.bool,
  calendar: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};